import React, { useEffect, useState } from 'react';
import i18n from 'i18n-js';
import { useConfirm } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import { VehiclesGroupsActions } from 'state/modules/vehiclesGroups';
import withWidth from '@material-ui/core/withWidth';
import { LocationsWidget } from 'components/Locations';
import { withRouter } from 'react-router-dom';

const VehicleGroupLocations = ({ id }) => {
  const [locationSelected, setLocationSelected] = useState(null);
  const onDeleteLocation = () => {
    dispatch(VehiclesGroupsActions.fetchRemoveLocationFromVehiclesGroups(id, locationSelected));
    setLocationSelected(null);
  };
  const [toggleDeleteLocation, RemoveVGLocationConfirm] = useConfirm({
    title: i18n.t('locations.delete_message'),
    message: i18n.t('locations.remove_message_description'),
    cancelText: i18n.t('common.cancel'),
    confirmText: i18n.t('common.yes'),
    onConfirm: onDeleteLocation,
  });
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });
  const {
    current,
    onboarding: { steps },
  } = useSelector((state) => state.vehiclesGroups);

  const fetchVehiclesGroupsLocations = (id, params) => {
    dispatch(
      VehiclesGroupsActions.fetchVehiclesGroupsLocations(id, 'locations', 'assigned', params)
    );
  };

  useEffect(() => {
    if (current?.id) {
      fetchVehiclesGroupsLocations(current?.id, params);
    }
  }, [current]); // eslint-disable-line

  const handleChangePage = (event, newPage) => {
    const newParams = { ...params, page: newPage + 1 };
    setParams(newParams);
    fetchVehiclesGroupsLocations(current?.id, newParams);
  };

  return (
    <>
      <RemoveVGLocationConfirm />
      <LocationsWidget
        steps={steps}
        params={params}
        currentGroup={current}
        loading={steps?.locations?.assigned?.loading}
        pagination={steps?.locations?.assigned?.pagination}
        locations={steps?.locations?.assigned?.list}
        handleChangePage={handleChangePage}
        onDelete={(payload) => {
          setLocationSelected(payload);
          toggleDeleteLocation();
        }}
      />
    </>
  );
};

export default withWidth()(withRouter(VehicleGroupLocations));
